import { AGG } from './types';

export const apertureCesar = {
  id: 'aperture-cesar',
  label: 'Aperture Cesar',
  description: 'Report apertura punto vendita Cesar.',
  single_image: true,
  sections: [
    {
      id: 'meta',
      title: 'Meta',
      blocks: [
        {
          channel: 'meta',
          label: 'Panoramica',
          kpis: [
            { key: 'date_start',  label: 'Data di inizio', aggregation: AGG.AUTO_MIN },
            { key: 'date_end',    label: 'Data di fine',   aggregation: AGG.AUTO_MAX },
            { key: 'spend',       label: 'Importo speso',  aggregation: AGG.DISTINCT, unit: 'currency' },
            { key: 'reach',       label: 'Reach',          aggregation: AGG.DISTINCT },
            { key: 'impressions', label: 'Impression',     aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',            aggregation: AGG.DISTINCT, unit: 'currency' },
            { key: 'reactions',   label: 'Reactions',      aggregation: AGG.SUM },
          ],
        },
        {
          channel: 'meta',
          label: 'Carosello',
          adset_filter: 'carosello',
          kpis: [
            { key: 'reach',       label: 'Reach',      aggregation: AGG.SUM },
            { key: 'impressions', label: 'Impression', aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',        aggregation: AGG.SUM, unit: 'currency' },
            { key: 'reactions',   label: 'Reactions',  aggregation: AGG.SUM },
          ],
        },
        {
          channel: 'meta',
          label: 'Surprise Bag + Sconto',
          adset_filter: 'surprise bag',
          kpis: [
            { key: 'reach',       label: 'Reach',      aggregation: AGG.SUM },
            { key: 'impressions', label: 'Impression', aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',        aggregation: AGG.SUM, unit: 'currency' },
            { key: 'reactions',   label: 'Reactions',  aggregation: AGG.SUM },
          ],
        },
        {
          channel: 'meta',
          label: 'Foto inaugurazione',
          adset_filter: 'foto inaugurazione',
          kpis: [
            { key: 'reach',       label: 'Reach',      aggregation: AGG.SUM },
            { key: 'impressions', label: 'Impression', aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',        aggregation: AGG.SUM, unit: 'currency' },
            { key: 'reactions',   label: 'Reactions',  aggregation: AGG.SUM },
          ],
        },
      ],
    },
    {
      id: 'google',
      title: 'Google',
      blocks: [
        {
          channel: 'google',
          kpis: [
            { key: 'spend',       label: 'Importo speso',  aggregation: AGG.SUM, unit: 'currency' },
            { key: 'impressions', label: 'Impression',     aggregation: AGG.SUM },
            { key: 'cpm',         label: 'CPM',            aggregation: AGG.SUM, unit: 'currency' },
            { key: 'link_clicks', label: 'Click sul link', aggregation: AGG.SUM },
          ],
        },
      ],
    },
    {
      id: 'linkedin',
      title: 'LinkedIn',
      blocks: [
        {
          channel: 'linkedin',
          label: 'LinkedIn — Acqua & Sapone',
          kpis: [
            { key: 'reach',                  label: 'Reach',          aggregation: AGG.SUM },
            { key: 'impressions',            label: 'Impression',     aggregation: AGG.SUM },
            { key: 'reactions',              label: 'Reactions',      aggregation: AGG.SUM },
            { key: 'linkedin_interest_rate', label: '% Di interesse', aggregation: AGG.SUM, unit: 'percent' },
          ],
        },
        {
          channel: 'linkedin',
          label: 'LinkedIn — Cesar',
          kpis: [
            { key: 'reach',                  label: 'Reach',          aggregation: AGG.SUM },
            { key: 'impressions',            label: 'Impression',     aggregation: AGG.SUM },
            { key: 'reactions',              label: 'Reactions',      aggregation: AGG.SUM },
            { key: 'linkedin_interest_rate', label: '% Di interesse', aggregation: AGG.SUM, unit: 'percent' },
          ],
        },
      ],
    },
    {
      id: 'ig_organic',
      title: 'Instagram Organico',
      blocks: [
        {
          channel: 'ig_organic',
          label: 'Storia Organica IG',
          kpis: [
            { key: 'ig_story_impressions', label: 'Impression', aggregation: AGG.SUM },
          ],
        },
      ],
    },
  ],
};
